<template>
  <ul
    ref="categoryListRef"
    class="category__list"
    :class="{
      'category__list--scroll': mobileScroll
    }"
  >
    <CategoryTile
      v-for="category in categories"
      :key="category.uuid"
      :category="category"
    />
  </ul>
</template>

<script lang="ts" setup>
import type { CategoryItemParent, FilterCategory } from '~/types/catalog'

type Props = {
  fetching?: boolean
  categories: CategoryItemParent[] | FilterCategory[]
  mobileScroll?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  fetching: false,
  mobileScroll: false
})

const categoryListRef = ref<HTMLElement>()

onUpdated(() => {
  if (props.mobileScroll) {
    categoryListRef.value?.scroll({ left: 0 })
  }
})
</script>

<style lang="scss" scoped>
.category {
  &__list {
    display: grid;
    column-gap: 1rem;
    row-gap: 1rem;
    padding: 0;
    list-style-type: none;
    grid-template-columns: 1fr 1fr;
    margin: 0 0 3rem;

    @media only screen and (min-width: 740px) {
      grid-gap: 1.6rem;
      grid-template-columns: 1fr 1fr 1fr;
      margin: 3rem 0;
    }
    @media only screen and (min-width: 1024px) {
      grid-template-columns: repeat(auto-fit, minmax(24rem, 30rem));
    }
    @media only screen and (min-width: 1300px) {
      grid-template-columns: repeat(4, minmax(24rem, 30rem));
    }
    @media only screen and (min-width: 1560px) {
      grid-template-columns: repeat(5, minmax(24rem, 30rem));
    }

    @media only screen and (max-width: 740px) {
      &--scroll {
        position: relative;
        width: 100vw;
        display: flex;
        overflow-x: auto;
        margin: -1.6rem -1.6rem 0;
        padding: 1.6rem;
        grid-gap: 0;

        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        &::-webkit-scrollbar {
          display: none;
        }

        .category-tile {
          margin-right: 1rem;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
